module.exports = __webpack_public_path__ + "static/media/Valeria.Brito-CV.92f1fd5a.pdf";